<template>
    <googel-tag-manager v-bind:cookie-performance="this.cookiePerformance" v-bind:tracking="this.tracking"></googel-tag-manager>
</template>

<script>

let VueCookies =  require('vue3-cookies')
const { cookies } = VueCookies.useCookies()

export default {
    props: [
        'tracking',
        'cookiePerformance'
    ],
    watch: {
        cookiePerformance(value)
        {              
            this.prependScript();     
        }
    },
    methods: {
        prependScript() {
            if(cookies.isKey('cookie-performance') && this.tracking !== undefined && this.tracking != '') {
                try {

                    let script = document.createElement('script');
                    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer','${this.tracking}');`
                    document.head.prepend(script);
    
                    let iframe = document.createElement('noscript')
                    iframe.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${this.tracking}" 
                    height="0" width="0" style="display:none;visibility:hidden"></iframe>`
                    document.body.prepend(iframe);
                    
                } catch (error) {
                    console.log(error);                    
                }
            }
        }
    }
}
</script>